module.exports = __webpack_public_path__ + "static/media/naec-stoneleigh.b540c9ae.jpg";